/**
 * What a CMS list shows when its query fails (QA 2026-09-14 CMS-56). TanStack keeps the
 * previous page in `data` while a query errors, so without this the operator kept reading rows
 * that no longer matched the filters on screen — with nothing saying the list was stale.
 */
import { useT } from '../../i18n';
import { cn } from '../../lib/cn';
import { Button } from '../ui/button';

export interface ListErrorProps {
  /** Re-runs the failed query. */
  onRetry?: (() => void) | undefined;
  className?: string;
}

export function ListError({ onRetry, className }: ListErrorProps) {
  const { t } = useT();
  return (
    <div
      role="alert"
      data-testid="list-error"
      className={cn(
        'flex flex-col items-center gap-2 px-4 py-6 text-center text-[13px] text-danger',
        className,
      )}
    >
      <span>{t('cms:table.loadFailed')}</span>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          {t('cms:table.retry')}
        </Button>
      )}
    </div>
  );
}
